export default class AppLoadError extends Error {
  constructor(message, cause) {
    super(`Error getting app: ${message}`, { cause })
  }
}
